<div class="flex flex-col items-center h-full">
  <div class="mt-32 text-3xl">Thanks!</div>
  <div class="flex items-center">
    <mat-icon class="check-icon"> check</mat-icon>
  </div>
  <p class="text-lg w-2/5 text-center">We've submitted your change request and we will be in touch shortly</p>
</div>
